import { render, staticRenderFns } from "./api-key.vue?vue&type=template&id=704d8c43"
import script from "./api-key.vue?vue&type=script&lang=js"
export * from "./api-key.vue?vue&type=script&lang=js"
import style0 from "./api-key.vue?vue&type=style&index=0&id=704d8c43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports